import React, { Component } from "react";
import "./App.scss";
import "./CompactTheme.scss";
import "devextreme/dist/css/dx.common.css";
import "devextreme/dist/css/dx.material.blue.light.compact.css";
import { Route, Switch } from "react-router-dom";
import { oidcSecure } from "@axa-fr/react-oidc-redux";
import AppContainer from "./AppContainer";
import PublicHome from "./home/components/PublicHome";
class App extends Component {
  componentDidMount() {
    document.body.classList.add("compact-theme");
  }
  render() {
    return (
      <>
        <Switch>
          <Route exact path="/login" component={PublicHome} />
          <Route path="/" component={oidcSecure(AppContainer)} />
        </Switch>
      </>
    );
  }
}
export default App;
